import { useOrganization } from '../contexts/OrganizationContext'

/**
 * Hook to get current organization ID for queries
 * Returns null if no organization (components should handle this gracefully)
 */
export function useOrganizationId() {
  const { organization } = useOrganization()
  return organization?.id || null
}

